<template>
  <div>
    <div class="mt-goods-top flex-row-align">
      <div class="mt-goods-content" style="padding-top: 30px;">
        <div class="mt-goods-title flex-row-align">
          <div class="bg-theme"></div>申请详情
        </div>
        <div class="mt-goods-row flex-row-align">
          <div class="mt-goods-row-name">姓名：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.applyName}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">联系方式：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.applyPhone}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">申请理由：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.applyReason}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">合作方式：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.applyCooperationType == 1 ? '个人' : '企业'}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">{{detailInfo.applyCooperationType == 1 ? '身份证号' : '税号'}}：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.idCardNo}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">{{detailInfo.applyCooperationType == 1 ? '身份证正面' : '营业执照'}}：</div>
          <div class="flex-row-align">
            <el-image
              v-if="detailInfo.frontImgUrl != null"
              class="mt-goods-row-img"
              :src="detailInfo.frontImgUrl"
              :preview-src-list="[detailInfo.frontImgUrl]"
              fit="contain"></el-image>
            <div class="mt-goods-row-txt" v-if="detailInfo.frontImgUrl == null">--</div>
          </div>
        </div>
        <div v-if="detailInfo.applyCooperationType == 1" class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">身份证反面：</div>
          <div class="flex-row-align">
              <el-image
                v-if="detailInfo.backImgUrl != null"
                class="mt-goods-row-img"
                :src="detailInfo.backImgUrl"
                :preview-src-list="[detailInfo.backImgUrl]"
                fit="contain"></el-image>
              <div class="mt-goods-row-txt" v-if="detailInfo.backImgUrl == null">--</div>
          </div>
        </div>
        <div v-if="detailInfo.applyCooperationType == 2" class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">企业名称：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.enterpriseName}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">银行卡号：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.bankCardNo}}
          </div>
        </div>
        <div v-if="detailInfo.applyCooperationType == 2" class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">开户行：</div>
          <div class="mt-goods-row-txt">
            {{detailInfo.bankName}}
          </div>
        </div>
        <div class="mt-goods-row flex-row">
          <div class="mt-goods-row-name">银行卡照片：</div>
          <div class="flex-row-align">
            <el-image
              v-if="detailInfo.bankImgUrl != null"
              class="mt-goods-row-img"
              :src="detailInfo.bankImgUrl"
              :preview-src-list="[detailInfo.bankImgUrl]"
              fit="contain"></el-image>
            <div class="mt-goods-row-txt" v-if="detailInfo.bankImgUrl == null">--</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCommissionUserApplyLogDetailById } from '@/api/commission'
export default {
  name: 'DlApplyDetail',
  props: {
    infoId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      detailInfo: {
        applyName:'',
        applyPhone: '',
        applyReason: '',
        applyCooperationType: '',
        idCardNo: '',
        frontImgUrl:'',
        backImgUrl:'',
        bankCardNo:'',
        bankImgUrl:''
      }
    }
  },
  watch: {
    "infoId":{
      handler(newVal, oldVal){
        this.detailInfoFun();
      }
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    detailInfoFun(){
      var that = this;
      fetchCommissionUserApplyLogDetailById({id:that.infoId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.detailInfo = data;
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/components/Detail.vue